// عنوان التقرير الصريح المستخدم في اسم الرابط ومعاينة واتساب/البريد.
const MONTHS = {
  ar: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
       "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  en: ["January", "February", "March", "April", "May", "June",
       "July", "August", "September", "October", "November", "December"],
};

const monthName = (month, year, lang) => {
  const names = MONTHS[lang === "en" ? "en" : "ar"];
  const index = Math.max(1, Math.min(12, Number(month) || 1)) - 1;
  return `${names[index]} ${year}`;
};

// مثال: «رواتب مايو 2026 — فرع دبي» / "Salaries May 2026 — Dubai Branch"
export const reportTitle = (data, lang, { kind = "salary", custom = false } = {}) => {
  const ar = lang !== "en";
  const scope = data.employees?.length === 1
    ? data.employees[0].employee_name
    : data.branch_name || (ar ? "كل الفروع" : "All branches");
  const head = kind === "attendance"
    ? (ar ? "تقرير حضور" : "Attendance report")
    : (ar ? "رواتب" : "Salaries");
  const period = custom
    ? `${data.period_start} → ${data.period_end}`
    : monthName(data.accounting_month ?? String(data.period_start).slice(5, 7),
                data.accounting_year ?? String(data.period_start).slice(0, 4), lang);
  return `${head} ${period} — ${scope}`;
};
